import type { AbstractControl } from '@angular/forms';

/**
 * Whether a form control should show invalid UI (red border, error slot).
 * Errors appear after the user edits the field (`dirty`) or submits the form —
 * not on focus/blur alone (`touched`).
 *
 * @param forceInvalid When true (e.g. parent group cross-field error), show invalid
 *   UI once the control is dirty or the form was submitted — even if the control
 *   itself has no field-level errors.
 */
export function ancShowFieldError(
    control: AbstractControl | null | undefined,
    submitted: boolean,
    forceInvalid = false
): boolean {
    if (!control) {
        return false;
    }

    const triggered = control.dirty || submitted;
    if (!triggered) {
        return false;
    }

    return control.invalid || forceInvalid;
}
